import { getProjectCases } from "@/services/project/cases.service"
import { MaterialBlance, createMaterialBalance, getProjectStreams, updateMaterialBalance } from "@/services/project/material-balance.service"
import { useRequest } from "ahooks"
import { Form, Input, Modal, ModalProps, Select } from "antd"
import TextArea from "antd/es/input/TextArea"
import { useEffect } from "react"
import { createRoot } from "react-dom/client"

interface ConfigMaterialBalanceModalProps extends ModalProps {
  pId: string
  balance: MaterialBlance
  onSuccess?: () => void
  onCancel?: () => void
}

export const ConfigMaterialBalanceModal = (props: ConfigMaterialBalanceModalProps) => {
  const {onCancel, pId, onSuccess, balance} = props;
  const [form] = Form.useForm()
  const {data: cases = []} = useRequest(() => getProjectCases({pId: pId}))
  const {data: streams = []} = useRequest(() => getProjectStreams(pId))

  useEffect(() => {
    if (!balance) return;
    const formData = {
      ...balance,
      streams: (balance.streams || []).map(item => item.uuid)
    }

    form.setFieldsValue(formData)
  }, [balance])
  
  const onSave = async (values) => {
    const modalValues = {...values, streams: values.streams.map(item => {
      return {
        uuid: item
      }
    })}
    await updateMaterialBalance(modalValues, balance.id)
    onSuccess?.()
  }

  const caseOptions = cases.map(item => {
    return {
      label: `${item.name}[No: ${item.number}]`,
      value: item.id
    }
  })

  const streamOptions = streams.map((item) => {
    return {
      label: item.tag,
      value: item.uuid
    }
  })

  return <Modal
    {...props}
    width={660}
    maskClosable={false}
    okText="Save"
    open
    onOk={() => form.submit()}
    onCancel={onCancel}
  >
    <div>Config Material Balance</div>
    <Form
      form={form}
      onFinish={(values) => {
        onSave(values)
      }}
      className="mt-4"
    >
      <Form.Item label='Name' name='name' rules={[{ required: true, message: 'Please enter material balance name' }]}>
        <Input type='text' />
      </Form.Item>
      <Form.Item label='Cases' name='cases' rules={[{ required: true, message: 'Please select the cases' }]}>
        <Select options={caseOptions} mode="multiple" />
      </Form.Item>
      <Form.Item label='Streams' name='streams' rules={[{ required: true, message: 'Please select the streams' }]}>
        <Select options={streamOptions} mode="multiple" />
      </Form.Item>
      <Form.Item label='Description' name='description'>
        <TextArea rows={3} />
      </Form.Item>
    </Form>
  </Modal>
}

ConfigMaterialBalanceModal.show = (props: ConfigMaterialBalanceModalProps) => {
  const div = document.createElement('div')
  document.body.appendChild(div)
  const root = createRoot(div);
  root.render(<ConfigMaterialBalanceModal
    {...props}
    onCancel={() => {
      props.onCancel?.()
      root.unmount()
    }}
    onSuccess={() => {
      props.onSuccess?.()
      root.unmount()
    }}
  />);
}